import React, {useState} from "react";
import {Alert, CustomInput, FormGroup, Label} from 'reactstrap';
import useGlobal from "../utils/globalStore";


function CovidStep3(props) {
    // eslint-disable-next-line
    const [globalState, globalActions] = useGlobal();
    const answers = globalState.answers;

    const [localStateContact, updateContact] = useState(answers.contactYesNo);

    const localOnChange = (event) => {
        updateContact(event.target.value);
        props.handleChange(event);
    }

    return (
        <div>
            <h4 className="covid-title">COVID Contact</h4>
            <hr className="my-2"  />
            <Alert color="light">
                Note: Close contact means face-to-face contact within 6 feet for a total of 15 minutes or more over a 24-hour period.
            </Alert>
            <FormGroup>
                <Label for="contactYesNo">4. Within the past 14 days, have you had close contact with anyone who has a confirmed or possible case of COVID-19?</Label>
                <div >
                    <CustomInput type="radio" id="contactYes" label="Yes"
                                 name="contactYesNo"
                                 checked={localStateContact === 'contactYes' }
                                 value="contactYes"
                                 onChange={localOnChange}
                    />
                    <CustomInput type="radio" id="contactNo" label="No"
                                 name="contactYesNo"
                                 checked={localStateContact === 'contactNo' }
                                 value="contactNo"
                                 onChange={localOnChange}
                    />
                </div>
            </FormGroup>
        </div>

    );
}

export default CovidStep3;